export default __webpack_public_path__ + "static/media/Holicef-500-mg-IV-ban.c1b5cb8a.jpg";